import MessageRow from './MessageRow';

export default MessageRow;
